export default __webpack_public_path__ + "static/media/Website images-16.6e88d648.jpg";